import axios from "axios";
var result = { Status: true, Message: "", Data: null };
export const saveProductTypeInfo = async (values , companyId) => {
    var result = { Status: true, Message: "", Data: null };   
    var mainData = {
        data : {
            TypeId: values.typeId,
            TypeName: values.typeName,
            TypeDesc: values.typeDesc,
            IsActive: values.isActive,
            CreatedBy: values.createdBy,
            CompanyId: companyId,
        }
    }
    if (values.typeId === '' || values.typeId === null) {
        try {
            const response = await axios.post(`/api/ProductType/Create`, mainData);
            if (response && response.status === 200) {
                return response.data;
            } else {
                result.Status = false;
                result.Message = "Something went wrong";
                return result;
            }
        } catch (error) {
            if (error.response.status === 401) {
                return error.response.status;
            } else {
                result.Status = false;
                result.Message = "Unhandled exception";
                return result;
            }
        }
    } else {
        mainData.data.TypeId = values.typeId;
        try {
            const response = await axios.put(`/api/ProductType/${mainData.data.TypeId}`, mainData.data)
            if (response && response.status === 200) {
                return response.data;
            } else {
                result.Status = false;
                result.Message = "Something went wrong";
                return result;
            }
        } catch (error) {
            if (error.response.status === 401) {
                return error.response.status;
            } else {
                result.Status = false;
                result.Message = "Unhandled exception";
                return result;
            }
        }
    }
}

export const GetProductTypeList = async (values) => {
    let response;
    var data = {
        CompanyId: values,
    }
    try {
        response = await axios.post(`/api/ProductType/GetProductTypeList`, data);
        if (response && response.status === 200) {
            return response.data.records;
        } else {
            console.error("GetUser Error:")
            return response.status;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        }
    }
}

export const GetProductTypeById = async (id) => {
    try {
        const response = await axios.post(`/api/ProductType/GetProductTypeById`, { id: id });
        if (response.status === 200) {
            return response.data;
        } else {
            return response.status;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        } else {
            let exceptionData = { expmessage: error.response.data.title, expstring: true }
            return exceptionData;
        }
    }
}
export const deleteProductType = async (values) => {
    try {
        var Deldata = {
            typeId: values.typeId,
        }
        const response = await axios.post(`/api/ProductType/Delete`, Deldata);
        if (response && response.status === 200) {
            return response.data;
        } else {
            result.Status = false;
            result.Message = "Something went wrong";
            return result;
        }
    } catch (error) {
        console.log(error)
    }
}

export const GetAllProductType = async (values) => {
    let response;
    try {
        response = await axios.post(`/api/ProductType/GetAllProductType`);
        if (response && response.status === 200) {
            return response.data.records;
        } else {
            console.error("GetUser Error:")
            return response.status;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        }
    }
}


